import { Badge, Tooltip } from '@mantine/core';
import { IconCheck, IconCopy } from '@tabler/icons-react';
import { CopyButton } from '@mantine/core';

export default function CopyButtonBadge({
  value,
  displayValue,
  timeout = 2000,
}: {
  value: string;
  displayValue?: string;
  timeout?: number;
}) {
  return (
    <CopyButton
      value={value}
      timeout={timeout}
    >
      {({ copied, copy }) => (
        <Tooltip
          label={copied ? 'Copied' : 'Copy'}
          withArrow
          position="right"
          zIndex={1001}
        >
          <Badge
            tt="none"
            className={`${copied || 'cursor-pointer'}`}
            color={copied ? 'teal' : 'gray'}
            variant="light"
            size="xs"
            onClick={(e) => {
              e.preventDefault();
              e.stopPropagation();
              copy();
            }}
            leftSection={copied ? <IconCheck size={10} /> : <IconCopy size={10} />}
          >
            {displayValue || value}
          </Badge>
        </Tooltip>
      )}
    </CopyButton>
  );
}
